<template>
  <floating-chat
    v-if="faqBotSource"
    text-color="#01407d"
    :content="faqBotSource"
    :textopen="componentText"
    :on-mouseover="onMouseOver"
    :on-mouseleave="onMouseLeave"
  />
</template>

<script>
import FloatingChat from '@/components/FloatingChat.vue';

export default {
  name: 'SecureChatBot',

  components: {
    FloatingChat,
  },

  data() {
    return {
      hover: false,
    };
  },

  computed: {
    faqBotSource() {
      return this.$store.getters.webChatURL;
    },
    componentText() {
      return this.hover ? 'Need help? Secure FAQ Bot' : '?';
    },
  },

  async beforeCreate() {
    await this.$store.dispatch('populateWebChatURL');
  },

  methods: {
    onMouseOver() {
      this.hover = true;
    },

    onMouseLeave() {
      this.hover = false;
    },
  },
};
</script>
